module.exports = __webpack_public_path__ + "static/media/DFFT.7fca710f.png";